
/**
* src/web/components/dashboard-user-page.jsx
* ユーザの月間サマリーページ（ポップアップ）
*/
import React from 'react'
import ReactDOM from 'react-dom'
import connect, { calcDetailsData } from '../../connects/dashboard-user-page'
import {
  Dialog,
} from 'react-toolbox/lib/dialog'
import {
  Button,
} from 'react-toolbox/lib/button'
import Loading from './loading.jsx'
import ChartView from 'react-highcharts'
import FontIcon from 'react-toolbox/lib/font_icon'
import MonthlySummaryTheme from './themes/user-monthly-summary-page.css'
import UserMonthlyActivitiesTable from './user-monthly-activities-table'
import moment from 'moment'
import _ from 'lodash'

const DETAILS_CHART_HEIGHT = 400
const COLORS = {
  diary:   '#2f7ed8',
  kpi:     '#0d233a',
  memo:    '#8bbc21',
  like:    '#910000',
  comment: '#1aadce',
  line1:   '#492970',
  line2:   '#f28f43'
}

class DashboardUserPage extends React.Component {
  state = { detailsChart: undefined }
  onClose = ()=> this.props.onClose()
  nextMonth = ()=> this.props.nextMonth(this.props)
  prevMonth = ()=> this.props.prevMonth(this.props)

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.actions !== nextProps.actions && nextProps.actions)
      this.setState({ detailsChart: this.generateChart(nextProps, this.state) })
  }

  generateChart = (props, state)=> {
    const { t, actions } = props
    const startDate = props.ui.startDate
    const detailsData = calcDetailsData(actions)
    return {
      chart: {
        type: 'scatter',
        height: DETAILS_CHART_HEIGHT,
      },
      title: { text: undefined },
      credits: { enabled: false },
      exporting: { enbaled: false },
      xAxis: {
        min: 1,
        max: startDate.clone().endOf('month').date(),
        startOnTick: true,
        endOnTick: true,
        tickInterval: 1,
        labels: {
          autoRotation: false,
          align: 'center',
          useHTML: true,
          formatter: function() {
            const date = startDate.clone().add(moment.duration(this.value - 1, 'day'))
            if (date.day() == 6) // 土曜日
              return `<span style="color: blue">${date.format('D<br/>ddd')}</span>`
            if (date.day() == 0) // 日曜日
              return `<span style="color: red">${date.format('D<br/>ddd')}</span>`
            return date.format('D<br/>ddd')
          }
        }
      },
      yAxis: {
        min: 0, max: 24,
        reversed: true,
        tickInterval: 3,
        title: { text: undefined },
        labels: {
          autoRotation: false,
          formatter: function() {
            return moment('2000-01-01 00:00:00').add(moment.duration(this.value, 'hour')).format('HH:mm')
          }
        }
      },
      tooltip: {
        shared: true,
        crosshairs: true,
        useHTML: true,
        formatter: function() {
          let text = `${this.point.time.slice(0, 5)} - ${this.point.series.name}`
          if (this.point.reported_diff) {
            text += ` (${this.point.reported_at.slice(5, 10)})<br/><span style="color:red">${this.point.reported_diff}日遅れ</span>`
          }
          return text
        },
      },
      series: [{
        color: COLORS.diary,
        name: t('diary:diary'),
        data: detailsData.diary,
        marker: {
          symbol: 'circle',
          radius: 10,
        }
      }, {
        color: COLORS.kpi,
        name: t('diary:kpi'),
        data: detailsData.kpi,
        marker: {
          symbol: 'circle',
          radius: 10,
        }
      }, {
        color: COLORS.memo,
        name: t('diary:memo'),
        data: detailsData.memo,
        marker: {
          symbol: 'circle',
          radius: 10,
        }
      }, {
        color: COLORS.like,
        name: t('label:いいね'),
        data: detailsData.like,
        marker: {
          symbol: 'triangle',
          height: 10,
          width: 10,
        }
      }, {
        color: COLORS.comment,
        name: t('label:コメント'),
        data: detailsData.comment,
        marker: {
          symbol: 'triangle',
          height: 10,
          width: 10,
        }
      }]
    }
  }

  render() {
    const {
      t,
      ui,
      updateUI,
      user,
      actions,
      onClose,
      open,
      isFetching,
    } = this.props
    const endDate = ui.startDate.clone().endOf('month')

    return (
      <Dialog theme={MonthlySummaryTheme} 
          active={open}
          onEscKeyDown={this.onClose}
          onOverlayClick={this.onClose}
          title={t('label:月間サマリー', { name: user.name })}
          actions={[{ label: t('label:閉じる'), onClick: this.onClose, raised: true }]}>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0 20px' }}>
          <Button icon='navigate_before' onClick={this.prevMonth} />
          <span>{ui.startDate.format(t('format:month'))}</span>
          <Button icon='navigate_next' onClick={this.nextMonth} disabled={endDate.isAfter(moment())} />
        </div>
        <div style={{ height: DETAILS_CHART_HEIGHT }}>
          {this.state.detailsChart && <ChartView config={this.state.detailsChart} />}
          {isFetching && !this.state.detailsChart && <Loading />}
        </div>
      </Dialog>
    )
  }
}

export default connect(DashboardUserPage)



// WEBPACK FOOTER //
// ./src/web/components/dashboard-user-page.jsx